export default __webpack_public_path__ + "static/media/sub-banner-right-3.58ef734e.svg";